import React, { Fragment, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import ProjectDetailsSection from "./ProjectDetailsSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import { useLanguage } from "../../context/LanguageContext";

const ProjectDetails: React.FC = () => {
  const { slug } = useParams<{ slug?: string }>();
  const { t } = useLanguage();

  const currentProject =
    t.projects.items.find((p) => p.slug === slug) || t.projects.items[0];

  useEffect(() => {
    document.title = `${currentProject.title} | ${t.company.name}`;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentProject, t.company.name]);

  return (
    <Fragment>
      <div className="service-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle
              pageTitle={currentProject.title}
              pagesub={currentProject.industry}
            />
            <ProjectDetailsSection currentProject={currentProject} />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ProjectDetails;
